export const infraConfig = {
    apiEndpoint : "https://minsidabn-be.azurewebsites.net/api1",
    usePort: false,
    clientId: '417acfec-5b81-4d91-8a43-05a6a355f561', 
    identityServerEndpoint : "https://login.microsoftonline.com/bybnor.onmicrosoft.com/v2.0",
    documentsUrl: "https://minsidabn-docs.azurewebsites.net"
};

